<template>
    <a-modal 
        v-model="visible" 
        :title="$t('modal.work-rating')" 
        :closable="false" 
        :ok-text="$t('modal-btn.alter-confirm-btn-caption')" 
        :cancel-text="$t('modal-btn.alter-cancel-btn-caption')" 
        @ok="handleOk" 
        @cancel="handleCancel"
    >
        <!-- <h6>{{$t('reject-modal.title-application')}}</h6> -->
        <div>
            <a-date-picker 
                class="ml-10"
                :value="selectStartDate" 
                format="DD MMM, yyyy" 
                :placeholder="$t('form-placeholder.start-date')" 
                @change="onChangeStartDate"
            />
            <b style="font-size:20px"> {{$t('modal.to')}} </b>
                <!-- :disabledDate="current => current && current < moment()" -->
            <a-date-picker 
                class="ml-10" 
                :value="selectEndDate" 
                format="DD MMM, yyyy" 
                :placeholder="$t('form-placeholder.end-date')" 
                @change="onChangeEndDate"
            />
                <!-- :disabledDate="current => current && current < moment()" -->
        </div>
        <a-form
            id="components-form-demo-normal-login"
            class="login-form"
            :hideRequiredMark="true"
        >   
            <a-form-item 
                    class="mb-5" 
                    :label="$t('form-label.project')" 
                    :colon="false"
                >
                <a-input
                    class="form-input"
                    :placeholder="$t('form-placeholder.project')"
                    v-model="project"
                >
                </a-input>
            </a-form-item>
            <a-form-item 
                class="mb-5" 
                :label="$t('form-label.note')" 
                :colon="false"
            >
                <a-textarea
                    class="form-input"
                    :placeholder="$t('form-placeholder.note')"
                    v-model="note"
                >
                </a-textarea>
            </a-form-item>
            <h6 style="font-weight: 500"> {{$t('form-label.alter-performance rating')}} </h6>
            <a-rate :value="ratingValue" allow-half @change="onRatingChange"/>
        </a-form>
    </a-modal>
</template>

<script>
import moment from 'moment';
import { ratingClient } from "../../../../api/config.js";
import { toastMixin } from "../../../../mixins/ToastMixin.js";
export default {
    name: "AddTrackRecordModal",
    mixins: [ toastMixin ],
    data(){
        return{
            selectStartDate: "",
            selectEndDate: "",
            ratingValue: 1,
            startDate:"",
            endDate: "",
            project: "",
            note: "",
            visible: false,
            applicantId: "",
            type: "",
            moment: moment,
        }
    },
    methods:{
        showModal(id, type) {
            this.visible = true;
            this.applicantId = id;
            this.type = type;
        },
        handleCancel(){
            this.visible = false;
        },
       
        onRatingChange(e){
            this.ratingValue = e;
        },
        onChangeStartDate(e){
            this.selectStartDate = e;
            this.startDate = e.format('DD-MM-yyyy');
        },
        onChangeEndDate(e){
            this.selectEndDate = e;
            this.endDate = e.format('DD-MM-yyyy');
        },
        handleOk(){
            let data = {
                "applicationId": this.applicantId,
                "type": this.type,
                "startDate": this.startDate,
                "endDate": this.endDate,
                "project": this.project,
                "rating": this.ratingValue,
                "note": this.note,
            }
            ratingClient.AddRating(data).then(res => {
                if (!res.networkError){
                    if (res.status == 201){
                        this.successToast(this.$t('toast-success-messages.success'));
                        this.visible = false;
                    }else{
                        this.errorToast(this.$t('toast-error-message.error') + res.status);
                    }
                }else{
                    this.errorToast(this.$t('toast-error-message.network-error'));
                }
            })
        },
    }
}
</script>

<style>

</style>